import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';

import { UsuariosModel } from './usuarios.model';
import { UsuariosService } from './usuarios.service';
import { BasicValidators } from '../shared/basic-validators';
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Funcoes} from "../funcoes";
import {PaisesService} from "../paises/paises.service";
import {UsuariosCargosService} from "../usuarios-cargos/usuarios-cargos.service";
import {Global} from "../global";
import {UnidadesService} from "../unidades/unidades.service";
import {LoginService} from "../login/login.service";
import {UsuariosCargosNomesService} from "../usuarios-cargos-nomes/usuarios-cargos-nomes.service";


@Component({
  selector: 'app-usuarios-form',
  templateUrl: './usuarios-form.component.html'
})
export class UsuariosFormComponent extends Components implements OnInit {

  form: FormGroup;
  title: string;
  user: UsuariosModel = new UsuariosModel();
  isMinhaConta: boolean = false;
  listPaises = [];
  listCargos = [];
  listCargosNomes = [];
  listUnidades = [];
  listTimezone = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  obj = {"0":"3","1":"45"};

  constructor(
    formBuilder: FormBuilder,
    protected router: Router,
    private route: ActivatedRoute,
    private usuariosService: UsuariosService,
    private paisesService: PaisesService,
    private unidadesService: UnidadesService,
    private usuariosCargosService: UsuariosCargosService,
    private usuariosCargosNomesService: UsuariosCargosNomesService,
    private loginService: LoginService,
    private _location: Location,
    protected translate: TranslateService,
    public func: Funcoes,
    public global: Global
  ) {
    super();

    this.form = formBuilder.group({
      id_usuario: [],
      id_cargo: ['', [
        Validators.required
      ]],
      id_cargo_nome: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]],
      senha: ['', [Validators.minLength(8)]],
      senha_conf: ['', BasicValidators.igualSenha],
      telefone: [],
      celular: [],
      cidade: [],
      estado: [],
      id_pais: [],
      id_unidade: [],
      date_format: [],
      time_format: [],
      timezone: [],
      avatar: [],
      idioma: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_usuario'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarUsuario');
      }else{
        this.title = (id) ? this.func.traduzir('front.visualizarUsuario') : this.func.traduzir('front.cadastrarNovoUsuario');
      }


      this.paisesService.get()
        .subscribe(
          json => {
            this.listPaises = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      this.unidadesService.get()
        .subscribe(
          json => {
            this.listUnidades = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      this.usuariosCargosService.get()
        .subscribe(
          json => {
            this.listCargos = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      this.usuariosCargosNomesService.get()
        .subscribe(
          json => {
            this.listCargosNomes = json.Payload;
          },
          error => {
            this.func.showErro(error.json());
          });

      this.usuariosService.timezone()
        .subscribe(
          json => {
            this.listTimezone = json.Payload
          },
          error => {
            this.func.showErro(error.json());
          });

      if (!id) {
        return;
      }

      // verifica se a pagina é do usuario
      if(id == this.func.getTokenInfo()['uid']){
        this.isMinhaConta = true;
      }

      this.usuariosService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarUsuario') + ': ' + json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarUsuario') + ': ' + json.Payload[0].nome;
            }
            this.user = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },error => {
            this.trataErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      userValue = this.user; //this.form.value;

    if (userValue.id_usuario) {
      result = this.usuariosService.editar(userValue, userValue.id_usuario);
    } else {
      result = this.usuariosService.adicionar(userValue);
    }

    result.subscribe(
      (data) => {
        let url = window.location.pathname.split('/');
        if(url[2] == 'usuarios' && this.loginService.getUserInfo(true).id_usuario == url[3]){
          this._location.back();
          return true;
        }

        this.router.navigate(['/painel', 'usuarios']);
      },
      (erro) => {
        this.enviando = false;
        let json = erro.json();
        this.trataErro(json);

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }

      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarios/usuarios-form.component.ts